function generateUrlParamsFromObject(obj) {
    let paramsString = "";
    const entries = Object.entries(obj);
    entries.forEach(([key, value], index) => {
        if (value) {
            index === 0 ? (paramsString += `${key}=${value}`) : (paramsString += `&${key}=${value}`);
        }
    });
    return paramsString;
}

export { generateUrlParamsFromObject };
//# sourceMappingURL=generateUrlParamsFromObject.js.map
